import { render } from "./NailPanelSelectedTests.vue?vue&type=template&id=749322b2"
import script from "./NailPanelSelectedTests.vue?vue&type=script&lang=js"
export * from "./NailPanelSelectedTests.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/testInfo/selectedTestsPreview/NailPanelSelectedTests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "749322b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('749322b2', __exports__)) {
    console.log('reload')
    api.reload('749322b2', __exports__)
  }
  
  module.hot.accept("./NailPanelSelectedTests.vue?vue&type=template&id=749322b2", () => {
    console.log('re-render')
    api.rerender('749322b2', render)
  })

}


export default __exports__